import { fmt, type LauncherStrings as Strings } from '../shared/locale';

// the Creja AI cloud (docs/brand/icona): frame 0° at rest, 5° and 10° only as frames of its wobble (launcher.css);
// all three in one 648×384 box, so the drawing is centred on the button whatever frame shows
const CHAT_ICON =
  '<svg class="aca-icon-cloud" viewBox="0 0 648 384" aria-hidden="true" focusable="false"><path class="aca-f0" d="M22.3 288H44.7V312H67V336H201.1V312H290.5V288H312.8V264H335.2V312H312.8V360H446.9V336H513.9V360H469.2V384H290.5V336H223.4V360H44.7V336H22.3V312H0V144H22.3V288ZM536.3 336H513.9V312H536.3V336ZM581 312H558.6V336H536.3V288H581V312ZM603.3 288H581V264H603.3V288ZM648 240H625.7V264H603.3V216H625.7V192H648V240ZM625.7 192H603.3V144H625.7V192ZM268.1 96H245.8V169H223.4V145H201.1V121H156.4V97H89.4V73H178.8V97H223.4V73H245.8V48H268.1V96ZM89.4 121H44.7V144H22.3V120H44.7V97H89.4V121ZM491.6 144H469.2V48H491.6V96H536.3V120H491.6V144ZM581 120H603.3V144H558.6V120H536.3V96H581V120ZM424.6 24H312.8V48H268.1V24H290.5V0H424.6V24ZM469.2 48H424.6V24H469.2V48Z"/><path class="aca-f5" d="M31.9 313.4L54.1 311.5L56.2 335.4L78.5 333.4L80.6 357.4L214.1 345.7L212 321.8L301.1 314L299 290.1L321.2 288.1L319.1 264.2L341.4 262.3L345.6 310.1L323.3 312L327.5 359.8L461.1 348.2L459 324.2L525.8 318.4L527.9 342.3L483.3 346.2L485.4 370.1L307.3 385.7L303.2 337.9L236.4 343.7L238.5 367.6L60.4 383.2L58.3 359.3L36 361.3L34 337.3L11.7 339.3L-2.9 171.9L19.3 170L31.9 313.4ZM548 316.5L525.8 318.4L523.7 294.5L545.9 292.6L548 316.5ZM590.4 288.7L568.2 290.6L570.3 314.5L548 316.5L543.8 268.6L588.4 264.7L590.4 288.7ZM610.6 262.8L588.4 264.7L586.3 240.8L608.5 238.9L610.6 262.8ZM651 211.1L628.7 213L630.8 236.9L608.5 238.9L604.3 191.1L626.6 189.1L624.5 165.2L646.8 163.3L651 211.1ZM624.5 165.2L602.2 167.2L598.1 119.3L620.3 117.4L624.5 165.2ZM260 100.7L237.7 102.7L244.1 175.4L221.8 177.4L219.7 153.4L197.5 155.4L195.4 131.5L150.9 135.4L148.8 111.5L82 117.3L79.9 93.4L168.9 85.6L171 109.5L215.6 105.6L213.5 81.7L235.7 79.8L233.5 54.9L255.8 52.9L260 100.7ZM84.1 141.2L39.6 145.1L41.6 168L19.3 170L17.2 146.1L39.5 144.1L37.5 121.2L82 117.3L84.1 141.2ZM486.8 129.1L464.5 131L456.1 35.4L478.4 33.4L482.6 81.3L527.1 77.4L529.2 101.3L484.7 105.2L486.8 129.1ZM573.7 97.4L596 95.4L598.1 119.3L553.5 123.2L551.5 99.3L529.2 101.3L527.1 77.4L571.6 73.5L573.7 97.4ZM409.5 15.4L298.2 25.1L300.3 49L255.8 52.9L253.7 29L276 27.1L273.9 3.2L407.4-8.5L409.5 15.4ZM456.1 35.4L411.6 39.3L409.5 15.4L454 11.5L456.1 35.4Z"/><path class="aca-f10" d="M43.5 338.8L65.5 334.9L69.7 358.5L91.7 354.6L95.9 378.3L227.9 355L223.7 331.4L311.7 315.8L307.6 292.2L329.6 288.3L325.4 264.7L347.4 260.8L355.8 308.1L333.8 312L342.1 359.2L474.1 336L470 312.3L536 300.7L540.1 324.3L496.1 332.1L500.3 355.7L324.2 386.7L315.9 339.5L249.9 351.1L254.1 374.8L78 405.8L73.9 382.2L51.9 386L47.7 362.4L25.7 366.3L-3.5 200.8L18.5 197L43.5 338.8ZM558 296.8L536 300.7L531.8 277L553.8 273.2L558 296.8ZM597.8 265.4L575.8 269.3L580 292.9L558 296.8L549.6 249.5L593.6 241.8L597.8 265.4ZM615.7 237.9L593.6 241.8L589.5 218.1L611.5 214.2L615.7 237.9ZM651.3 182.9L629.3 186.7L633.5 210.4L611.5 214.2L603.2 167L625.2 163.1L621 139.5L643 135.6L651.3 182.9ZM621 139.5L599 143.3L590.6 96.1L612.7 92.2L621 139.5ZM252.2 107L230.2 110.9L242.9 182.8L220.9 186.7L216.7 163L194.7 166.9L190.6 143.3L146.5 151L142.4 127.4L76.4 139L72.2 115.4L160.2 99.9L164.4 123.5L208.4 115.7L204.2 92.1L226.2 88.2L221.9 63.6L243.9 59.7L252.2 107ZM80.5 162.7L36.5 170.4L40.5 193.1L18.5 197L14.3 173.3L36.3 169.4L32.4 146.8L76.4 139L80.5 162.7ZM480.6 115.5L458.6 119.4L441.9 24.8L464 20.9L472.3 68.2L516.3 60.4L520.5 84.1L476.5 91.8L480.6 115.5ZM564.5 76.3L586.5 72.4L590.6 96.1L546.6 103.8L542.5 80.2L520.5 84.1L516.3 60.4L560.3 52.7L564.5 76.3ZM393.8 8.9L283.7 28.3L287.9 52L243.9 59.7L239.7 36.1L261.7 32.2L257.6 8.6L389.6-14.7L393.8 8.9ZM441.9 24.8L397.9 32.6L393.8 8.9L437.8 1.2L441.9 24.8Z"/></svg>';
const CLOSE_ICON =
  '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M18.3 5.71a1 1 0 00-1.41 0L12 10.59 7.11 5.7A1 1 0 105.7 7.11L10.59 12 5.7 16.89a1 1 0 101.41 1.41L12 13.41l4.89 4.89a1 1 0 001.41-1.41L13.41 12l4.89-4.89a1 1 0 000-1.4z"/></svg>';

/**
 * A one-tap reply under the bubble text: sends `message`, or does `do` (`pick_vehicle` opens the store's car picker,
 * `vehicle_results` the compatible wheels of the saved car), or just opens the chat.
 */
export interface TeaserAction {
  label: string;
  message?: string;
  do?: 'pick_vehicle' | 'vehicle_results';
}

/** The proactive bubble above the launcher: what it says and, optionally, the message a click sends for the visitor. */
export interface Teaser {
  text: string;
  message?: string;
  actions?: TeaserAction[];
}

export interface Launcher {
  el: HTMLButtonElement;
  setOpen(open: boolean): void;
  setBusy(busy: boolean): void;
  setStrings(s: Strings): void;
  /** Unread badge (agent replies received while the panel is closed); 0 removes it. */
  setUnread(count: number): void;
  /** Text next to the icon ("Trova i cerchi per la tua auto"); empty = icon only. */
  setLabel(label: string): void;
  /** Brand image (https) in place of the chat icon; null = default icon. The close icon is unchanged. */
  setIcon(url: string | null): void;
  /** Icon only (the label folds away; hover or focus brings it back on desktop). */
  setCompact(compact: boolean): void;
  /** Shows the bubble and plays the attention ring once. */
  showTeaser(teaser: Teaser): void;
  hideTeaser(): void;
  destroy(): void;
}

export interface LauncherHandlers {
  /** The visitor clicked the bubble text. */
  onTeaser?(teaser: Teaser): void;
  /** The visitor tapped one of the bubble's replies. */
  onTeaserAction?(action: TeaserAction, teaser: Teaser): void;
  /** The visitor closed the bubble with its X. */
  onTeaserDismiss?(): void;
}

/**
 * Shows/removes the unread badge on the launcher button (`data-unread`, drawn by launcher.css) and updates its label.
 * Exported so the panel can badge the launcher directly when the loader does not wire `PanelContext.onUnread`.
 */
export function applyLauncherUnread(el: HTMLElement, count: number, label: string): void {
  const n = Math.max(0, Math.floor(count));
  if (n > 0) el.setAttribute('data-unread', n > 9 ? '9+' : String(n));
  else el.removeAttribute('data-unread');
  if (el.getAttribute('aria-expanded') !== 'true') el.setAttribute('aria-label', label);
}

export function createLauncher(parent: HTMLElement, strings: Strings, panelId: string, onActivate: () => void, onIntent: () => void, handlers: LauncherHandlers = {}): Launcher {
  let s = strings;
  let open = false;
  let unread = 0;
  let label = '';
  let iconUrl: string | null = null;
  let teaser: Teaser | null = null;
  const el = document.createElement('button');
  el.type = 'button';
  el.className = 'aca-launcher';
  el.setAttribute('aria-controls', panelId);
  el.setAttribute('aria-haspopup', 'dialog');
  const icon = document.createElement('span');
  icon.className = 'aca-launcher-icon';
  const text = document.createElement('span');
  text.className = 'aca-launcher-label';
  el.append(icon, text);

  const bubble = document.createElement('div');
  bubble.className = 'aca-teaser';
  bubble.setAttribute('role', 'status');
  bubble.hidden = true;
  const bubbleText = document.createElement('button');
  bubbleText.type = 'button';
  bubbleText.className = 'aca-teaser-text';
  const bubbleClose = document.createElement('button');
  bubbleClose.type = 'button';
  bubbleClose.className = 'aca-teaser-close';
  bubbleClose.innerHTML = CLOSE_ICON;
  const bubbleActions = document.createElement('div');
  bubbleActions.className = 'aca-teaser-actions';
  bubble.append(bubbleText, bubbleClose, bubbleActions);

  const ariaLabel = () => (open ? s.launcherClose : unread > 0 ? fmt(s.launcherUnread, { n: unread }) : label ? `${label}${/[.?!]$/.test(label) ? '' : '.'} ${s.launcherOpen}` : s.launcherOpen);
  const render = () => {
    if (!open && iconUrl) {
      const img = document.createElement('img');
      img.className = 'aca-icon-img';
      img.src = iconUrl;
      img.alt = '';
      // a broken image must not leave an empty button
      img.addEventListener('error', () => {
        iconUrl = null;
        render();
      }, { once: true });
      icon.replaceChildren(img);
    } else if (open || !icon.querySelector('.aca-icon-cloud')) icon.innerHTML = open ? CLOSE_ICON : CHAT_ICON;
    text.textContent = label;
    el.classList.toggle('aca-labelled', !!label);
    el.setAttribute('aria-label', ariaLabel());
    el.setAttribute('aria-expanded', String(open));
    bubbleClose.setAttribute('aria-label', s.teaserClose);
  };
  render();

  const hideTeaser = () => {
    teaser = null;
    bubble.hidden = true;
    el.classList.remove('aca-nudge');
  };

  el.addEventListener('click', onActivate);
  // Warm up the panel chunk on first sign of intent.
  el.addEventListener('pointerenter', onIntent, { once: true });
  el.addEventListener('focus', onIntent, { once: true });
  el.addEventListener('touchstart', onIntent, { once: true, passive: true });
  bubbleText.addEventListener('pointerenter', onIntent, { once: true });
  bubbleText.addEventListener('click', () => {
    const t = teaser;
    hideTeaser();
    if (t) handlers.onTeaser?.(t);
  });
  bubbleClose.addEventListener('click', () => {
    hideTeaser();
    handlers.onTeaserDismiss?.();
  });
  // the bubble comes first in the DOM: it reads (and tabs) before the button it points to
  parent.append(bubble, el);

  return {
    el,
    setOpen(v) {
      open = v;
      if (v) hideTeaser();
      render();
    },
    setBusy(b) {
      el.setAttribute('aria-busy', String(b));
    },
    setStrings(next) {
      s = next;
      render();
    },
    setUnread(count) {
      unread = Math.max(0, Math.floor(count));
      applyLauncherUnread(el, unread, ariaLabel());
    },
    setLabel(next) {
      label = next.trim().slice(0, 60);
      render();
    },
    setIcon(url) {
      if (url === iconUrl) return;
      iconUrl = url;
      render();
    },
    setCompact(compact) {
      el.classList.toggle('aca-compact', compact);
    },
    showTeaser(next) {
      if (open || !next.text.trim()) return;
      teaser = next;
      bubbleText.textContent = next.text.trim().slice(0, 160);
      bubbleActions.replaceChildren(
        ...(next.actions ?? []).slice(0, 2).map((action, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = i === 0 ? 'aca-teaser-action aca-teaser-action-main' : 'aca-teaser-action';
          b.textContent = action.label.trim().slice(0, 40);
          b.addEventListener('pointerenter', onIntent, { once: true });
          b.addEventListener('click', () => {
            const t = teaser;
            hideTeaser();
            if (t) handlers.onTeaserAction?.(action, t);
          });
          return b;
        }),
      );
      bubbleActions.hidden = !bubbleActions.childElementCount;
      bubble.hidden = false;
      // restart the ring when a second bubble follows the first
      el.classList.remove('aca-nudge');
      void el.offsetWidth;
      el.classList.add('aca-nudge');
    },
    hideTeaser,
    destroy() {
      bubble.remove();
      el.remove();
    },
  };
}
